import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, MovimentoItemEstoque } from 'eddydata-lib';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MovimentoItemEstoqueService extends BaseResourceService<MovimentoItemEstoque> {

  constructor(
    protected injector: Injector
  ) {
    super(`movimentos-itens-estoque`, injector);
  }

  public enviarSaidaBnafar(lista: { codigoIbge: string, payload: any }): Observable<any> {
    return this.http.post<any>(
      `${this.login.cidade.id}/${this.api}/bnafar/saida`, lista, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public enviarPosicaoEstoqueBnafar(lista: { codigoIbge: string, payload: any }): Observable<any> {
    return this.http.post<any>(
      `${this.login.cidade.id}/${this.api}/bnafar/posicao-estoque`, lista, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public consultarLoteBnafar(codigoIbge: string, protocolo: string): Observable<any> {
    return this.http.get<any>(
      `${this.login.cidade.id}/${this.api}/bnafar/consultar-lote/${codigoIbge}/${protocolo}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public verificarLoteExistenteProdutoUnidade(lote: string, produtoUnidadeId: number): Observable<any> {
    return this.http.get<any>(
      `${this.login.cidade.id}/${this.api}/verificar-lote-existente/${produtoUnidadeId}/${lote}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }


  public inconsistenciasLoteBnafar(codigoIbge: string, protocolo: string): Observable<any> {
    return this.http.get<any>(
      `${this.login.cidade.id}/${this.api}/bnafar/inconsistencias/${codigoIbge}/${protocolo}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public excluirSaidaBnafar(codigoIbge: string, protocolo: string): Observable<any> {
    return this.http.delete<any>(
      `${this.login.cidade.id}/${this.api}/bnafar/saida/${codigoIbge}/${protocolo}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public excluirPosicaoEstoqueBnafar(codigoIbge: string, protocolo: string): Observable<any> {
    return this.http.delete<any>(
      `${this.login.cidade.id}/${this.api}/bnafar/posicao-estoque/${codigoIbge}/${protocolo}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

  public posicaoEstoqueBnafar(dataReferencia: string, pendente: boolean, orgao: number,estoque: number): Observable<any> {
    return this.http.get<any>(
      `${this.login.cidade.id}/${this.api}/posicao-estoque-bnafar/${orgao}/${dataReferencia}/${pendente}/${estoque}`, this.httpOptions()).pipe(
        map(res => res),
        catchError(err => this.handleError(err))
      );
  }

}
